export enum ActionType {
  OpenScreen = "OPEN_SCREEN",
  OpenUrl = "OPEN_URL",
  CallTo = "CALL_TO",
  EmailTo = "EMAIL_TO"
}
